import CatalystBg0 from '../images/catalyst-bg-0.svg'
import CatalystBg1 from '../images/catalyst-bg-1.svg'
import CatalystBg2 from '../images/catalyst-bg-2.svg'
import CatalystBg3 from '../images/catalyst-bg-3.svg'
import CatalystBg4 from '../images/catalyst-bg-4.svg'

import CatalystQuestionBg from '../images/catalyst-question-bg.png'
import CatalystQuestionBg2x from '../images/catalyst-question-bg@2x.png'
import { findIndex, intersection, isEqual } from 'lodash-es'
import jwtDecode from 'jwt-decode'

export const MIN_LIKERT_QUESTION_RESPONSE_OR_RATE = 1
export const MAX_LIKERT_QUESTION_RESPONSE_OR_RATE = 5

export const YOU_PARAMETER_ID = "3b13b3f5-f418-408c-a451-39cd81fa9d89";
export const YOU_FILTER = [{
  id: YOU_PARAMETER_ID,
  values: []
}]
export const notEnoughRespondentsError = "Not enough respondents";

export const ROLE_EDITOR = 'EDITOR'

export const IMPROVEMENT_PROJECT_PHASE_ACTIVE = 'ACTIVE'
export const IMPROVEMENT_PROJECT_PHASE_ANALYSIS = 'ANALYSIS'

export const isRetina = (first, second) => {
  if (window.devicePixelRatio >= 2) {
    return second;
  }
  return first;
}

export const CATALYST_QUESTION_BG_IMAGE = isRetina(
  CatalystQuestionBg,
  CatalystQuestionBg2x
);

const THEME_STYLES = [
  {
    bgColor: "#23233F",
    bgImage: CatalystBg0
  },
  {
    bgColor: "#E37290",
    bgImage: CatalystBg1
  },
  {
    bgColor: "#FFC44A",
    bgImage: CatalystBg2
  },
  {
    bgColor: "#0070C0",
    bgImage: CatalystBg3
  },
  {
    bgColor: "#7B7BB4",
    bgImage: CatalystBg4
  }
];

export const getThemeStyle = (surveyThemeIndex) => {
  return THEME_STYLES[surveyThemeIndex]
}

export const hasOpenQuestions = (catalysts) => {
  let hasQuestions = false;
  for( var i = 0, len = catalysts.length; i < len; i++ ) {
    if( catalysts[i].openQuestions && catalysts[i].openQuestions.length > 0 ) {
      hasQuestions = true;
      break;
    }
  }
  return hasQuestions;
}

export const setCookie = (cName, cValue, expDays) => {
  let date = new Date();
  date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
  const expires = "expires=" + date.toUTCString();
  document.cookie = cName + "=" + cValue + "; " + expires + "; path=/";
}

export const getCookie = (cName) => {
  const name = cName + "=";
  const cDecoded = decodeURIComponent(document.cookie); //to be careful
  const cArr = cDecoded.split('; ');
  let res;
  cArr.forEach(val => {
    if (val.indexOf(name) === 0) res = val.substring(name.length);
  })
  return res;
}

export const getThemeTitleByDriverId = (id, catalysts) => {
  let themeTitle = "";
  catalysts.map((catalyst) => {
    catalyst.drivers.map((driver) => {
      if (driver.id === id) {
        themeTitle = catalyst.title;
      }
      return null;
    })
    return null;
  })
  return themeTitle;
}

export const getThemeTitleByStatementId = (id, catalysts) => {
  let themeTitle = "";

  catalysts.map((catalyst) => {
    catalyst.questions.map((question) => {
      if (question.id === id) {
        themeTitle = catalyst.title;
      }
      return null;
    })
    return null;
  })
  return themeTitle;
}

export const getThemeIndexByThemeId = (id, catalysts) => {
  return findIndex(catalysts, (c) => c.id === id);
}

export const getThemeIndexByThemeTitle = (title, catalysts) => {
  return findIndex(catalysts, (c) => c.title === title);
}

export const darkenLightenColor = (color, amount) => {
  return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
}

export const isNullOrUndefined = (value) => {
  return value === undefined || value === null;
}

export const getAvailableQuestions = (questionType, questionniareParameters, theme) => {
  const respondentParameterOptionIds = questionniareParameters.map(p => p.chosenOptionId)
  let fieldName
  if (questionType === 'likert') {
    fieldName = 'questions'
  } else if (questionType === 'open') {
    fieldName = 'openQuestions'
  } else {
    throw new Error(`Assertion failed: unknown question type ${questionType}`)
  }
  return theme[fieldName].filter(q => (q.availability === null) || (intersection(q.availability.acceptableParameterOptionIds, respondentParameterOptionIds).length > 0))
}

export const getAvailableThemes = (questionniareParameters, surveyThemes) => {
  return surveyThemes.filter(t => {
    return (getAvailableQuestions('likert', questionniareParameters, t).length > 0) || (getAvailableQuestions('open', questionniareParameters, t).length > 0) 
  })
}

export const toNormalizedRespondentFilters = filters => {
  if (isEqual(filters, YOU_FILTER)) {
    return YOU_FILTER
  }
  if (filters.length === 0) {
    // The "everyone" filter is defined as an empty array (see parameter-filter_.js and survey.js:22)
    return undefined
  }
  // The filter component returns a list of selected values for each parameter.
  // If no values are selected for a parameter, its list is empty.
  // Filter out the empty lists so only actual selections are sent to the backend.
  return filters.filter(f => f.values.length > 0)
}

export const getBackendUrl = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:8080/survey/graphql'
  } else {
    const host = window.location.host
    return `https://${host}/survey/graphql`
  }
}

export const getSecondaryBackendUrl = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:4000/graphql'
  } else {
    const host = window.location.host
    return `https://${host}/v2/graphql`
  }
}

export const getUserRoles = (surveyId) => {
  const token = getCookie(surveyId)
  if (!token) return []
  const { roles } = jwtDecode(token)
  if (!roles) throw new Error('JWT is missing roles claim')
  return roles
}



// WEBPACK FOOTER //
// ./src/utilities/helpers.js